<template>
		
</template>

<script>

export default {
	data() {
		return {
			
		}
	},
	methods: {
	
	},
	components: {
	
	}
}
</script>
<style>
	body {
		margin: 0px;
	}
	
</style>